import { render, staticRenderFns } from "./DHFStats.vue?vue&type=template&id=318f9bcf&scoped=true&"
import script from "./DHFStats.vue?vue&type=script&lang=js&"
export * from "./DHFStats.vue?vue&type=script&lang=js&"
import style0 from "./DHFStats.vue?vue&type=style&index=0&id=318f9bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f9bcf",
  null
  
)

export default component.exports